import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const MuiButton = styled(Button)<{
  width?: string;
}>`
  text-transform: none;
  font-weight: medium;
  box-shadow: none !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 42px;
  border-radius: 21px !important;
  padding: 0 25px !important;

  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}
`;
